var _effectorFileName = "/src/pages/individual-lessons/index.page.tsx";
import { GetServerSideProps } from 'next';
import { allSettled, fork, serialize } from 'effector';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { individualLessonsPage, IndividualLessonsPage } from '@/page-content/individual-lessons';
import { DEFAULT_LOCALE } from '@/shared/config/i18n';
import { EFFECTOR_STATE_KEY } from '@/shared/lib/effector';
import { getPageContext } from '@/shared/lib/effector/page';
export const getServerSideProps: GetServerSideProps = async ctx => {
  const scope = fork();
  const locale = ctx.locale ?? DEFAULT_LOCALE;
  await allSettled(individualLessonsPage.open, {
    scope,
    params: getPageContext(ctx)
  });
  return {
    props: {
      [EFFECTOR_STATE_KEY]: serialize(scope),
      ...(await serverSideTranslations(locale, ['common', 'layout-header', 'layout-footer', 'layout-call-to-action', 'reviews', 'pricing', 'slider-cards', 'individual-lessons-page', 'individual-lessons-main', 'individual-lessons-pluses']))
    }
  };
};
export default IndividualLessonsPage;